import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

type StyledTableColumnHeaderProps = {
  align?: 'left' | 'center' | 'right';
  transform?: 'none' | 'uppercase' | 'capitalize';
  fontWeight?: 'normal' | 'bold';
};

const StyledTableColumnHeader = styled(TableCell)<StyledTableColumnHeaderProps>`
  font-weight: ${({ fontWeight }) => fontWeight || 'normal'};
  text-align: ${({ align }) => align || 'left'};
  text-transform: ${({ transform }) => transform || 'none'};
`;

export default StyledTableColumnHeader;
